// Header bell (plan 8.2.2 알림 9종 + extras). Per-user read state. The server sends kind + params; the web words
// title/body from i18n (`notif.<kind>.title/body`) and links to `href` (an app hash route).
import { z } from 'zod';
import { NotificationKind, Tone } from '../enums.js';
import { Count, EpochMs, Id } from '../common.js';

export const NotificationItem = z.object({
  id: Id,
  kind: NotificationKind,
  tone: Tone,
  at: EpochMs,
  read: z.boolean(),
  /** In-app route, e.g. `#/connect?tab=mine`, `#/settings?tab=views`. */
  href: z.string().regex(/^#\/[\w\-/?=&.,~%]*$/).max(300),
  /** Numbers/keys only: tool, days, count, minutes, version, role id, reason category, team id, case id… */
  params: z.record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null()])),
});
export type NotificationItem = z.infer<typeof NotificationItem>;

export const NotificationListQuery = z.object({ cursor: z.string().max(200).optional(), limit: z.coerce.number().int().min(1).max(100).default(30), unread: z.enum(['0', '1']).default('0') });
export const NotificationListResponse = z.object({ items: z.array(NotificationItem), unreadCount: Count, nextCursor: z.string().nullable() });
export const NotificationParams = z.object({ notificationId: Id });
export const ReadAllResponse = z.object({ unreadCount: z.literal(0) });

export const notificationsSchemas = { NotificationItem, NotificationListQuery, NotificationListResponse, NotificationParams, ReadAllResponse } as const;
